import { NavLink, Outlet } from 'react-router';
import { canWrite, useAuth } from '../../auth';
import { cn } from '../../ui';

/**
 * The phone version: big touch targets, one thing on screen at a time, and a tab bar at the bottom for the jobs done
 * standing at the shelves. It sits outside the desktop menu; "Full site" goes back to that.
 */
export function MobileLayout() {
  const { user } = useAuth();
  const writer = canWrite(user);
  const tabs = [
    { to: '/m', label: 'Home', end: true, icon: '⌂' },
    ...(writer ? [{ to: '/m/scan', label: 'Scan', end: false, icon: '◉' }, { to: '/m/put-away', label: 'Put away', end: false, icon: '⇩' }] : []),
    { to: '/m/find', label: 'Find', end: false, icon: '⌕' },
  ];
  return (
    <div className="flex min-h-dvh flex-col bg-slate-50">
      <header className="sticky top-0 z-20 flex items-center justify-between bg-slate-900 px-4 py-3 text-slate-100">
        <span className="text-lg font-semibold">BrickLoop</span>
        <a
          href="/"
          className="text-sm text-slate-300 underline"
          onClick={() => {
            try {
              sessionStorage.setItem('bl_full_site', '1');
            } catch {
              /* private mode: the redirect just happens again */
            }
          }}
        >
          Full site
        </a>
      </header>
      <main className="mx-auto w-full max-w-md flex-1 p-4 pb-28">
        <Outlet />
      </main>
      <nav aria-label="Phone menu" className="fixed inset-x-0 bottom-0 z-20 border-t border-slate-200 bg-white pb-[env(safe-area-inset-bottom)]">
        <ul className="mx-auto flex max-w-md">
          {tabs.map((t) => (
            <li key={t.to} className="flex-1">
              <NavLink
                to={t.to}
                end={t.end}
                className={({ isActive }) => cn('flex min-h-16 flex-col items-center justify-center gap-0.5 text-xs', isActive ? 'font-semibold text-slate-900' : 'text-slate-500')}
              >
                <span className="text-2xl leading-none" aria-hidden="true">
                  {t.icon}
                </span>
                {t.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
